import React, {ComponentType, useState} from "react";
import ToastDialog from "external-components/toast-dialog/index"
import { IHandlers, IServices } from 'external-components/toast-dialog/types'
import { ToastType, IToastDialogProps } from "shared-types/index"

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";

const NS = 'ToastDialogContainer';

const propsKeys: string[] = keys<IToastDialogProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function(all: IServices) {

  /**
    * Sorts 'all' into IServices, IProps and IContainerProps
    */
  const {ToastActions}: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices;
  let props: IToastDialogProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IToastDialogProps;

  const [msg, setMsg] = useState<string>("");
  const [type, setType] = useState<ToastType>(ToastType.info);
  const [hideDismissBtn, setHideDismissBtn] = useState<boolean>(false);
  const [isImportant, setIsImportant] = useState<boolean>(false);

  const [fullProps, setFullProps] = useState<IToastDialogProps>(null);

  if (fullProps) {
    props = {...fullProps};
  } else {
    props.msg = msg;
    props.type = type;
    props.hideDismissBtn = hideDismissBtn;
    props.isImportant = isImportant;
  }

  ToastActions.handleShowToast((msg: string, type: ToastType, hideDismissBtn: boolean, isImportant: boolean) => {
    setMsg(msg);
    setType(type);
    setHideDismissBtn(hideDismissBtn);
    setIsImportant(isImportant);
  });

  ToastActions.handleShowToastFullOptions((fullProps: IToastDialogProps) => {
    setFullProps(fullProps);
  });

  ToastActions.handleClearToast(() => {
    setMsg("");
    setFullProps(null);
  });

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    handleClose: () => {
      setMsg("");
    }
  }

  return ReactUtilsService.containerWrap(
    <ToastDialog {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2AToastDialog: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [] as never[], // no continer props needed
  servicesKeys
];
